import { DataSource } from '@client/core/data/concerns/data-source';
import { fromJson, JsonResponse } from '@client/core/data/concerns/parses-from-json';
import { HttpResponse } from '@client/core/http/types';
import {
  SubscriptionPlanKeyV1,
  SubscriptionPlanKeyV2,
  SubscriptionPlanKeyV2Analysis,
} from '@client/features/billing/config';
import { PlanChangeProjection } from '@client/features/billing/models/plan-change-projection';

export class PlanChangeProjectionDataSource extends DataSource {
  /**
   * @see app/Http/Controllers/Api/Billing/PlanChangeProjectionController.php
   */
  async getPlanProjection(
    ownerId: number,
    tryPlanKey: SubscriptionPlanKeyV1 | SubscriptionPlanKeyV2 | SubscriptionPlanKeyV2Analysis,
  ): Promise<PlanChangeProjection> {
    const response = await this.httpClient.get<HttpResponse<JsonResponse>>(
      `/workspace/${ownerId}/billing/plan-change-projection/${tryPlanKey}`,
    );

    return fromJson(PlanChangeProjection, response.data.data);
  }
}
